<template>
  <v-row>
    <v-col cols="12" class="mt-0 mb-1 pb-0 pt-2">
      <v-textarea
        clearable
        class="flex-md-grow-1"
        dense
        auto-grow
        outlined
        filled
        autocomplete="off"
        :label="label"
        :prepend-inner-icon="icon"
        :rows="rows"
        :disabled="disabled"
        v-model="local_value"
        :rules="validation_rules"
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TextArea",
  props: {
    label: {
      type: String,
      default: "Details",
    },
    icon: {
      type: String,
      default: "mdi-script-text-outline",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: String,
      default: "5",
    },
    validation_rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: String,
      default: "",
    }
  },
  computed: {
    local_value: {
      get() {
        return this.value;
      },
      set(new_value) {
        this.$emit("input", new_value);
      },
    },
  }
};
</script>